import { forwardRef, useRef } from 'react'
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles'

import Cancel from '@assets/images/cancel.png'

export default function AddingFailedModal({
	open,
	handleButton,
	message,
}) {
	const theme = useTheme()
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
	const descriptionElementRef = useRef(null)

	return (
		<Dialog
			className="w-full"
			open={open}
			maxWidth="xs"
			fullWidth
			fullScreen={fullScreen}
			TransitionComponent={Transition}
			scroll="paper">
			<DialogContent>
				<DialogContentText
					className="h-72 gap-y-10 flex flex-col"
					tabIndex={-1}
					ref={descriptionElementRef}
					component="div">
					<img
						src={Cancel}
						alt="Correct Checking"
						width={200}
						className="mx-auto"
					/>
					<Grid className="text-lg lg:text-xl text-center">{message}</Grid>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					component="div">
					<Grid item className="p-3 w-5/12" component="div">
						<Button
							fullWidth
							onClick={handleButton}
							color="secondary"
							size="large"
							variant="contained">
							ตกลง
						</Button>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

const Transition = forwardRef(function Transtition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})
